export function accessTokenFromOidcStorage(storageString) {
    if (!storageString)
        return null;
    try {
        const stored = JSON.parse(storageString);
        const accessToken = stored?.access_token;
        return typeof accessToken === 'string' && accessToken !== ''
            ? accessToken
            : null;
    }
    catch {
        return null;
    }
}
